import { colors, statusColors, theme } from '@/styles'

interface Props {
  hasError: boolean
  menuHeight: number
  valueHeight?: number
}

export const getCustomSelectStyle = ({ hasError, menuHeight, valueHeight = 34 }: Props) => ({
  container: base => ({
    ...base,
    fontSize: theme.fonts.fontSize14,
    fontFamily: theme.fonts.textCondensedFont,
  }),
  input: base => ({
    ...base,
    'input': {
      fontSize: theme.fonts.fontSize14,
      fontFamily: theme.fonts.textCondensedFont,
    },
  }),
  singleValue: base => ({
    ...base,
    color: colors.heading,
  }),
  control: (base, state) => ({
    ...base,
    border: 'none',
    boxShadow: `0 -1px 0  ${hasError ? colors.error : state.isFocused ? colors.violet : colors.heading} inset`,
    backgroundColor: state.isDisabled ? statusColors.statusWhiteGray : 'white',
    borderRadius: 'none',
    minHeight: '34px',
    '&:hover': {
      boxShadow: `0 -2px 0  ${hasError ? colors.error : state.isFocused ? colors.violet : colors.heading} inset`,
    },
    ...(state.isDisabled && {
      pointerEvents: 'auto',
      cursor: 'not-allowed',
      '&:hover': {
        boxShadow: `0 -1px 0  ${hasError ? colors.error : colors.heading} inset`,
      },
    }),
  }),
  valueContainer: (base, state) => ({
    ...base,
    color: colors.heading,
    minHeight: state.hasValue ? `${valueHeight}px` : '34px',
    paddingLeft: 0,
  }),
  multiValue: base => ({
    ...base,
    backgroundColor: theme.colors.statusWhiteGray,
  }),
  multiValueRemove: (base, state) => ({
    ...base,
    display: state.selectProps.isDisabled ? 'none' : 'flex',
    ':hover': state.selectProps.isDisabled
      ? {}
      : {
          backgroundColor: theme.colors.statusRed,
          color: theme.colors.error,
        },
    cursor: state.selectProps.isDisabled ? 'not-allowed' : 'pointer',
  }),
  menuPortal: base => ({
    ...base,
    zIndex: 5,
  }),
  menu: base => ({
    ...base,
    boxShadow: 'none',
    border: `2px solid ${colors.violet}`,
    marginTop: '1px',
    width: 'auto',
    minWidth: '100%',
    right: 0,
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    display: state.selectProps.isClearable && state.hasValue ? 'none' : 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: `0 0 0 4px`,
    svg: {
      fill: colors.label,
      width: '16px',
      height: '16px',
    },
  }),
  menuList: base => ({
    ...base,
    background: colors.white,
    maxHeight: menuHeight ? `${menuHeight}px` : '180px',
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: colors.greyLight,
      border: `1px solid ${colors.bgDark}`,
    },
    '&::-webkit-scrollbar-track': {
      background: colors.bgDark,
    },
  }),
  option: (base, state) => ({
    ...base,
    ':hover': {
      backgroundColor: state.isDisabled ? 'transparent' : colors.bgLight,
    },
    backgroundColor: state.isSelected && !state.isDisabled ? colors.bgDark : 'transparent',
    padding: '12px 16px',
    cursor: state.isDisabled ? 'not-allowed' : 'pointer',
    color: state.isDisabled ? colors.greyLight : colors.paragraph,
  }),
  indicatorSeparator: base => ({
    ...base,
    display: 'none',
  }),
  placeholder: (base, state) => ({
    ...base,
    color: colors.greyLight,
    opacity: state.isDisabled ? 0.5 : 1,
  }),
  clearIndicator: base => ({
    ...base,
    cursor: 'pointer',
    padding: 0,
    border: ` 1px solid ${colors.grey}`,
    borderRadius: '50%',
    svg: {
      fill: colors.grey,
      width: '16px',
      height: '16px',
    },
  }),
})
